/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import FilterHistoryPayload from './FilterHistoryPayload';

/**
 * The FilterHistoryRequest model module.
 * @module model/FilterHistoryRequest
 * @version 1.0.0
 */
class FilterHistoryRequest {
    /**
     * Constructs a new <code>FilterHistoryRequest</code>.
     * @alias module:model/FilterHistoryRequest
     * @param screenKey {String} 
     * @param screenLabel {String} 
     * @param title {String} 
     * @param payload {module:model/FilterHistoryPayload} 
     */
    constructor(screenKey, screenLabel, title, payload) { 
        
        FilterHistoryRequest.initialize(this, screenKey, screenLabel, title, payload);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, screenKey, screenLabel, title, payload) { 
        obj['screen_key'] = screenKey;
        obj['screen_label'] = screenLabel;
        obj['title'] = title;
        obj['payload'] = payload;
    }

    /**
     * Constructs a <code>FilterHistoryRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/FilterHistoryRequest} obj Optional instance to populate.
     * @return {module:model/FilterHistoryRequest} The populated <code>FilterHistoryRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new FilterHistoryRequest();

            if (data.hasOwnProperty('screen_key')) {
                obj['screen_key'] = ApiClient.convertToType(data['screen_key'], 'String');
            }
            if (data.hasOwnProperty('screen_label')) {
                obj['screen_label'] = ApiClient.convertToType(data['screen_label'], 'String');
            }
            if (data.hasOwnProperty('title')) {
                obj['title'] = ApiClient.convertToType(data['title'], 'String');
            }
            if (data.hasOwnProperty('is_named')) {
                obj['is_named'] = ApiClient.convertToType(data['is_named'], 'Boolean');
            }
            if (data.hasOwnProperty('payload')) {
                obj['payload'] = FilterHistoryPayload.constructFromObject(data['payload']);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>FilterHistoryRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>FilterHistoryRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of FilterHistoryRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['screen_key'] && !(typeof data['screen_key'] === 'string' || data['screen_key'] instanceof String)) {
            throw new Error("Expected the field `screen_key` to be a primitive type in the JSON string but got " + data['screen_key']);
        }
        // ensure the json data is a string
        if (data['screen_label'] && !(typeof data['screen_label'] === 'string' || data['screen_label'] instanceof String)) {
            throw new Error("Expected the field `screen_label` to be a primitive type in the JSON string but got " + data['screen_label']);
        }
        // ensure the json data is a string
        if (data['title'] && !(typeof data['title'] === 'string' || data['title'] instanceof String)) {
            throw new Error("Expected the field `title` to be a primitive type in the JSON string but got " + data['title']);
        }
        // validate the optional field `payload`
        if (data['payload']) { // data not null
          FilterHistoryPayload.validateJSON(data['payload']);
        }

        return true;
    }


}

FilterHistoryRequest.RequiredProperties = ["screen_key", "screen_label", "title", "payload"];

/**
 * @member {String} screen_key
 */
FilterHistoryRequest.prototype['screen_key'] = undefined;

/**
 * @member {String} screen_label
 */
FilterHistoryRequest.prototype['screen_label'] = undefined;

/**
 * @member {String} title
 */
FilterHistoryRequest.prototype['title'] = undefined;

/**
 * @member {Boolean} is_named
 */
FilterHistoryRequest.prototype['is_named'] = undefined;

/**
 * @member {module:model/FilterHistoryPayload} payload
 */
FilterHistoryRequest.prototype['payload'] = undefined;






export default FilterHistoryRequest;

